import React, { useContext, ComponentType, FC } from 'react';
import { Location, NavigateOptions, Params, useLocation, useNavigate, useParams } from 'react-router';
import { UrlUtil } from '@everfi/reactifi';
import environment from '../environment';
import { AppContext } from '../layout/Main';
import { AppContext as AppContextType } from '@/layout/main.context';

type RouterProps = {
  goBack: () => void;
  location: Location;
  searchParams: URLSearchParams;
  params: {};
  push: (path: string, options: NavigateOptions, removeStartSlash: boolean) => void;
  replace: (path: string) => void;
};

type RouteProps = {
  jwt: string;
  [key: string]: any;
};

export type RoutedContainerProps = RouterProps &
  RouteProps & {
    params: Readonly<Params<string>>;
    routeParams: Readonly<Params<string>>;
  };

type Props = {
  Container: ComponentType<any>;
  [key: string]: any;
};

const RoutedContainer: FC<Props> = ({ Container, ...rest }) => {
  const { accessToken, currentRuleSetName } = useContext(AppContext) as AppContextType;
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const commonProps: Partial<RoutedContainerProps> = {
    router: {
      goBack: () => navigate(-1),
      location,
      searchParams,
      params: {}, // used to avoid an error in NavTabs
      push: (path: string, options: NavigateOptions, removeStartSlash = true) => {
        let newPath = !removeStartSlash ? path : UrlUtil.PathHelper.ensureNoStartSlash(path);
        if (!newPath.includes('current_rule_set_name') && !!currentRuleSetName) {
          newPath += `${newPath.includes('?') ? '&' : '?'}current_rule_set_name=${currentRuleSetName}`;
        }
        navigate(newPath === '' ? '..' : newPath, options);
      },
    },
    route: {
      // TODO: figure out what parts of the environment really belong here
      ...environment,
      jwt: accessToken,
    },
    params: useParams(),
    routeParams: useParams(),
  };
  commonProps.router.replace = (path: string) => commonProps.router.push(path, { replace: true });
  return <Container {...(commonProps as any)} {...rest} />;
};

RoutedContainer.displayName = 'RoutedContainer';

export default RoutedContainer;
